const registrationTimeout = process.env.REACT_APP_REGISTRATION_TIMEOUT
  ? parseInt(process.env.REACT_APP_REGISTRATION_TIMEOUT)
  : 10 * 60 * 1000;

export default { registrationTimeout };
